export default __webpack_public_path__ + "static/media/gallery-13-2.185590e0.webp";